/**
 * 🛰️ PriceCabinet (行情組裝櫃 · Sovereign Component)
 * 職責：讀取全體實登行情案例索引，在地圖上渲染行情社區標記（簡易版行情 Logo），
 * 提供一鍵跳轉「查看完整行情數據分析」與側邊欄快速搜尋定位。
 */

import { SovereignCabinet } from '../../core/cabinet-base.js';

const FALLBACK_HTML = "<div class=\"price-cabinet-panel\">\n    <!-- 頂部控制列 -->\n    <div class=\"price-controls\">\n        <label class=\"price-toggle-label\">\n            <input type=\"checkbox\" id=\"toggle-price-layer\">\n            <span>地圖顯示行情案例</span>\n        </label>\n        <span class=\"badge-count\" id=\"price-count-badge\">載入中...</span>\n    </div>\n\n    <!-- 即時搜尋 -->\n    <div class=\"search-wrap\">\n        <span class=\"search-icon\">🔍</span>\n        <input type=\"text\" id=\"price-search\" class=\"price-search-input\" placeholder=\"搜尋行情案名、社區或路段...\" />\n    </div>\n\n    <!-- 案例卡片列表 -->\n    <div class=\"price-list\" id=\"price-items\">\n        <div class=\"empty-state\">正在載入行情案例索引…</div>\n    </div>\n</div>";

const FALLBACK_CSS = ":host {\n    display: block;\n    font-family: -apple-system, BlinkMacSystemFont, \"PingFang TC\", \"Noto Sans TC\", sans-serif;\n    color: #e2e8f0;\n    font-size: 13px;\n    line-height: 1.5;\n}\n\n.price-cabinet-panel {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.price-controls {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 10px;\n    background: #1e293b;\n    border-radius: 8px;\n    border: 1px solid #334155;\n}\n\n.price-toggle-label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: 600;\n    color: #f8fafc;\n    cursor: pointer;\n    font-size: 12.5px;\n}\n\n.price-toggle-label input[type=\"checkbox\"] {\n    accent-color: #f59e0b;\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n}\n\n.badge-count {\n    background: #d97706;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 700;\n    padding: 1px 7px;\n    border-radius: 999px;\n}\n\n.search-wrap {\n    position: relative;\n    width: 100%;\n}\n\n.price-search-input {\n    width: 100%;\n    padding: 7px 10px 7px 30px;\n    background: #0f172a;\n    border: 1px solid #334155;\n    border-radius: 6px;\n    color: #f8fafc;\n    font-size: 12px;\n    box-sizing: border-box;\n    outline: none;\n    transition: border-color 0.2s;\n}\n\n.price-search-input:focus {\n    border-color: #f59e0b;\n}\n\n.search-icon {\n    position: absolute;\n    left: 9px;\n    top: 50%;\n    transform: translateY(-50%);\n    opacity: 0.5;\n    font-size: 12px;\n    pointer-events: none;\n}\n\n.price-list {\n    max-height: 280px;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding-right: 4px;\n}\n\n.price-list::-webkit-scrollbar {\n    width: 4px;\n}\n.price-list::-webkit-scrollbar-thumb {\n    background: #334155;\n    border-radius: 2px;\n}\n\n.price-item {\n    background: #1e293b;\n    border: 1px solid #334155;\n    border-radius: 6px;\n    padding: 8px 10px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.price-item:hover {\n    border-color: #f59e0b;\n    background: #243248;\n    transform: translateY(-1px);\n}\n\n.price-item-top {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 6px;\n}\n\n.price-item-title {\n    font-weight: 600;\n    color: #f8fafc;\n    font-size: 12.5px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex: 1;\n}\n\n.price-item-cat {\n    font-size: 10px;\n    padding: 1px 5px;\n    border-radius: 4px;\n    background: rgba(245, 158, 11, 0.15);\n    color: #fbbf24;\n    border: 1px solid rgba(245, 158, 11, 0.3);\n    white-space: nowrap;\n}\n\n.price-item-meta {\n    font-size: 11px;\n    color: #94a3b8;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.price-item-actions {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 2px;\n}\n\n.price-cta-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 11px;\n    color: #fbbf24;\n    text-decoration: none;\n    padding: 3px 8px;\n    border-radius: 4px;\n    background: rgba(245, 158, 11, 0.1);\n    border: 1px solid rgba(245, 158, 11, 0.35);\n    transition: all 0.2s ease;\n    font-weight: 600;\n}\n\n.price-cta-btn:hover {\n    background: #f59e0b;\n    color: #0f172a;\n    border-color: #f59e0b;\n}\n\n.price-cta-btn img {\n    width: 13px;\n    height: 13px;\n    display: block;\n}\n\n.empty-state {\n    text-align: center;\n    padding: 20px 0;\n    color: #64748b;\n    font-size: 12px;\n}";

const DEFAULT_REPORTS = [
  {
    "id": "zhongshan2-416-apt-lvr",
    "slug": "zhongshan2-416-apt-lvr",
    "title": "板橋中山路二段416巷1弄公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "板橋區",
    "address": "新北市板橋區中山路二段416巷1弄24號",
    "priceUrl": "https://price.hooky-home.com/apt/bq-zhongshan2504",
    "lat": 25.02127992601138,
    "lng": 121.4841060786013
  },
  {
    "id": "fuhua-aimei-lvr",
    "slug": "fuhua-aimei-lvr",
    "title": "馥華艾美社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區中山路一段222號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-fuhuaaimei",
    "lat": 25.013655619267485,
    "lng": 121.47123092651718
  },
  {
    "id": "jiangcui-one-lvr",
    "slug": "jiangcui-one-lvr",
    "title": "江翠ONE社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區華江一路150號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-jiangcui1-small",
    "lat": 25.035331250943592,
    "lng": 121.47389750090431
  },
  {
    "id": "dijing2-lvr",
    "slug": "dijing2-lvr",
    "title": "甲山林帝景2號社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區大漢街41號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-dijing2",
    "lat": 25.03146455055783,
    "lng": 121.46133723775876
  },
  {
    "id": "dijing7-lvr",
    "slug": "dijing7-lvr",
    "title": "甲山林帝景7號社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區華江三路38號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-dijing7",
    "lat": 25.036514148732934,
    "lng": 121.47800266742735
  },
  {
    "id": "dijing6-lvr",
    "slug": "dijing6-lvr",
    "title": "甲山林帝景6號社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區華江一路98號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-dijing6",
    "lat": 25.036165892955424,
    "lng": 121.47583049186126
  },
  {
    "id": "dijing5-lvr",
    "slug": "dijing5-lvr",
    "title": "甲山林帝景5號社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區華江九路35號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-dijing5",
    "lat": 25.033735300204363,
    "lng": 121.46596370401238
  },
  {
    "id": "dijing3-lvr",
    "slug": "dijing3-lvr",
    "title": "甲山林帝景3號社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區華江八路96號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-dijing3",
    "lat": 25.033762663572556,
    "lng": 121.46639621254538
  },
  {
    "id": "judan-tokyo-lvr",
    "slug": "judan-tokyo-lvr",
    "title": "巨蛋東京花園廣場社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區民生路三段315號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-judan-tokyo",
    "lat": 25.031145380102164,
    "lng": 121.4632941640018
  },
  {
    "id": "dijing1-lvr",
    "slug": "dijing1-lvr",
    "title": "甲山林帝景1號社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區華江三路172號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-dijing1",
    "lat": 25.03676205933883,
    "lng": 121.47566078510411
  },
  {
    "id": "juguang-apt-lvr",
    "slug": "juguang-apt-lvr",
    "title": "板橋莒光路公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "板橋區",
    "address": "新北市板橋區莒光路27巷3號",
    "priceUrl": "https://price.hooky-home.com/apt/bq-juguang941",
    "lat": 25.024829543648114,
    "lng": 121.47021694028615
  },
  {
    "id": "longjiang65-apt-lvr",
    "slug": "longjiang65-apt-lvr",
    "title": "台北市中山區龍江路65巷公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "中山區",
    "address": "臺北市中山區龍江路65巷14號",
    "priceUrl": "https://price.hooky-home.com/apt/tpe-zs-longjiang65-14",
    "lat": 25.050428901300034,
    "lng": 121.54109548512237
  },
  {
    "id": "imperial-garden-plaza-lvr",
    "slug": "imperial-garden-plaza-lvr",
    "title": "帝國花園廣場社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區華江一路119號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-imperial-garden",
    "lat": 25.035126384191543,
    "lng": 121.4744258076283
  },
  {
    "id": "wenkang30-apt-lvr",
    "slug": "wenkang30-apt-lvr",
    "title": "桃園市龜山區文康街公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "龜山區",
    "address": "桃園市龜山區文康街30號",
    "priceUrl": "https://price.hooky-home.com/apt/gs-wenkang350",
    "lat": 25.055655245154522,
    "lng": 121.37951739171547
  },
  {
    "id": "songxin79-lvr",
    "slug": "songxin79-lvr",
    "title": "永順大廈社區步行圈實價登錄分析",
    "category": "comm",
    "district": "信義區",
    "address": "臺北市信義區松信路79號",
    "priceUrl": "https://price.hooky-home.com/comm/tpe-xy-songxin79",
    "lat": 25.046149403610414,
    "lng": 121.57225831607734
  },
  {
    "id": "jueshi-huixing-lvr",
    "slug": "jueshi-huixing-lvr",
    "title": "崛世回興大社區步行圈實價登錄分析",
    "category": "comm",
    "district": "南區",
    "address": "台中市南區興大路396巷88號",
    "priceUrl": "https://price.hooky-home.com/comm/tc-nan-huixingda",
    "lat": 24.116655988961934,
    "lng": 120.67084684983931
  },
  {
    "id": "hanbao-yuan-lvr",
    "slug": "hanbao-yuan-lvr",
    "title": "漢寶苑社區步行圈實價登錄分析",
    "category": "comm",
    "district": "永和區",
    "address": "新北市永和區成功路一段132號",
    "priceUrl": "https://price.hooky-home.com/comm/ntp-yh-hanbaoyuan",
    "lat": 25.00216420018714,
    "lng": 121.5264849855663
  },
  {
    "id": "xinhai426-apt-lvr",
    "slug": "xinhai426-apt-lvr",
    "title": "板橋新海路公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "板橋區",
    "address": "新北市板橋區新海路426號",
    "priceUrl": "https://price.hooky-home.com/apt/bq-xinhai738",
    "lat": 25.027531487797237,
    "lng": 121.45827545560701
  },
  {
    "id": "yanping3-66-apt-lvr",
    "slug": "yanping3-66-apt-lvr",
    "title": "台北市大同區延平北路三段公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "大同區",
    "address": "臺北市大同區延平北路三段66巷16號",
    "priceUrl": "https://price.hooky-home.com/apt/tpe-dt-yanping257",
    "lat": 25.06537954537125,
    "lng": 121.51016945844987
  },
  {
    "id": "xiyuan-jixiang-lvr",
    "slug": "xiyuan-jixiang-lvr",
    "title": "西園吉祥社區步行圈實價登錄分析",
    "category": "comm",
    "district": "萬華區",
    "address": "台北市萬華區西園路二段152號",
    "priceUrl": "https://price.hooky-home.com/comm/tpe-wh-xiyuanjixiang",
    "lat": 25.030087777363278,
    "lng": 121.49609296165583
  },
  {
    "id": "renhua14-apt-lvr",
    "slug": "renhua14-apt-lvr",
    "title": "板橋仁化街公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "板橋區",
    "address": "新北市板橋區仁化街14號",
    "priceUrl": "https://price.hooky-home.com/apt/bq-renhua14",
    "lat": 25.03154800490742,
    "lng": 121.47458562487245
  },
  {
    "id": "fuzhou-heyi-a2-lvr",
    "slug": "fuzhou-heyi-a2-lvr",
    "title": "浮洲合宜住宅A2區社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區合安一路95號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-fuzhoua2",
    "lat": 24.999427212269403,
    "lng": 121.44849280825758
  },
  {
    "id": "fuzhou-heyi-a3-lvr",
    "slug": "fuzhou-heyi-a3-lvr",
    "title": "浮洲合宜住宅A3區社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區合宜路145號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-fuzhoua3",
    "lat": 24.99724388911116,
    "lng": 121.44664256816918
  },
  {
    "id": "fuzhou-heyi-a6-lvr",
    "slug": "fuzhou-heyi-a6-lvr",
    "title": "浮洲合宜住宅（森之道A6區）社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區合宜路1號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-fuzhoua6",
    "lat": 24.996739284942837,
    "lng": 121.44430787633773
  },
  {
    "id": "fuzhou-heyi-campus-lvr",
    "slug": "fuzhou-heyi-campus-lvr",
    "title": "浮洲合宜住宅（A2／A3／A6）社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區合宜路145號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-fuzhouheyi",
    "lat": 24.99724388911116,
    "lng": 121.44664256816918
  },
  {
    "id": "nanyaxi2-301-50-apt-lvr",
    "slug": "nanyaxi2-301-50-apt-lvr",
    "title": "板橋南雅西路二段301巷50弄公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "板橋區",
    "address": "新北市板橋區南雅西路二段301巷50弄2號",
    "priceUrl": "https://price.hooky-home.com/apt/bq-nanyaxi887",
    "lat": 25.017336417898715,
    "lng": 121.45216235264634
  },
  {
    "id": "lixin-caidie-lvr",
    "slug": "lixin-caidie-lvr",
    "title": "立信天禧采蝶社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區長江路一段／大漢街（立信天禧采蝶基地）",
    "priceUrl": "https://price.hooky-home.com/comm/bq-lixincaidie",
    "lat": 25.031654847802542,
    "lng": 121.46282196090861
  },
  {
    "id": "nanshan208-apt-lvr",
    "slug": "nanshan208-apt-lvr",
    "title": "中和南山路公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "中和區",
    "address": "新北市中和區南山路208巷12號",
    "priceUrl": "https://price.hooky-home.com/apt/zh-nanshan208489",
    "lat": 24.990117814664107,
    "lng": 121.50581627947905
  },
  {
    "id": "wenhua65-43-apt-lvr",
    "slug": "wenhua65-43-apt-lvr",
    "title": "三重文化南路65巷公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "三重區",
    "address": "新北市三重區文化南路65巷43號",
    "priceUrl": "https://price.hooky-home.com/apt/sc-wenhua583",
    "lat": 25.06074933995659,
    "lng": 121.49896665243118
  },
  {
    "id": "sichuan2-245-49-apt-lvr",
    "slug": "sichuan2-245-49-apt-lvr",
    "title": "板橋四川路二段245巷公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "板橋區",
    "address": "新北市板橋區四川路二段245巷49號四樓",
    "priceUrl": "https://price.hooky-home.com/apt/bq-sichuan24549",
    "lat": 24.992506944329506,
    "lng": 121.45202789887753
  },
  {
    "id": "sichuan2-99-2-12-apt-lvr",
    "slug": "sichuan2-99-2-12-apt-lvr",
    "title": "板橋四川路二段99巷2弄公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "板橋區",
    "address": "新北市板橋區四川路二段99巷2弄12號",
    "priceUrl": "https://price.hooky-home.com/apt/bq-sichuan9912",
    "lat": 24.994265662833456,
    "lng": 121.45230864959348
  },
  {
    "id": "zhongshan2-148-23-apt-lvr",
    "slug": "zhongshan2-148-23-apt-lvr",
    "title": "板橋中山路二段148巷公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "板橋區",
    "address": "新北市板橋區中山路二段148巷23號",
    "priceUrl": "https://price.hooky-home.com/apt/bq-zhongshan14823",
    "lat": 25.01637959097082,
    "lng": 121.47717336712758
  },
  {
    "id": "guangwu24-2-apt-lvr",
    "slug": "guangwu24-2-apt-lvr",
    "title": "板橋光武街24巷公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "板橋區",
    "address": "新北市板橋區光武街24巷2號",
    "priceUrl": "https://price.hooky-home.com/apt/bq-guangwu242",
    "lat": 25.025666051270456,
    "lng": 121.46786749715882
  },
  {
    "id": "wenhua-darenguo-lvr",
    "slug": "wenhua-darenguo-lvr",
    "title": "文化大人國社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區文化路二段182巷3弄48號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-wenhuadarenguo",
    "lat": 25.02865336934372,
    "lng": 121.47289239068839
  },
  {
    "id": "huangxiang-diguo-lvr",
    "slug": "huangxiang-diguo-lvr",
    "title": "皇翔帝國社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區四川路二段247號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-huangxiangdiguo",
    "lat": 24.992787601550848,
    "lng": 121.4507229790373
  },
  {
    "id": "zhongyang1-121-23-3-apt-lvr",
    "slug": "zhongyang1-121-23-3-apt-lvr",
    "title": "土城中央路一段121巷23弄公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "土城區",
    "address": "新北市土城區中央路一段121巷23弄3號",
    "priceUrl": "https://price.hooky-home.com/apt/ntp-tu-zhongyang1121",
    "lat": 24.987939523543425,
    "lng": 121.4479866856409
  },
  {
    "id": "daren53-2-3-apt-lvr",
    "slug": "daren53-2-3-apt-lvr",
    "title": "板橋大仁街53巷2弄公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "板橋區",
    "address": "新北市板橋區大仁街53巷2弄3號",
    "priceUrl": "https://price.hooky-home.com/apt/bq-daren5323",
    "lat": 25.0160250692354,
    "lng": 121.45450734352045
  },
  {
    "id": "longguan-lvr",
    "slug": "longguan-lvr",
    "title": "龍觀社區步行圈實價登錄分析",
    "category": "comm",
    "district": "土城區",
    "address": "新北市土城區金城路二段259號",
    "priceUrl": "https://price.hooky-home.com/comm/ntp-tu-longguan",
    "lat": 24.985956536211045,
    "lng": 121.46370171582582
  },
  {
    "id": "zhongyang1-211-6-10-apt-lvr",
    "slug": "zhongyang1-211-6-10-apt-lvr",
    "title": "土城中央路一段211巷6弄公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "土城區",
    "address": "新北市土城區中央路一段211巷6弄10號",
    "priceUrl": "https://price.hooky-home.com/apt/ntp-tu-zhongyang211610",
    "lat": 24.986253359526735,
    "lng": 121.4460478641308
  },
  {
    "id": "yuanyang-newworld-no3-lvr",
    "slug": "yuanyang-newworld-no3-lvr",
    "title": "遠揚新世界NO3社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區南雅南路二段144巷2號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-yuanyang-nw3",
    "lat": 24.996280523491162,
    "lng": 121.4514404650279
  },
  {
    "id": "yuanyang-newworld-no1-lvr",
    "slug": "yuanyang-newworld-no1-lvr",
    "title": "遠揚新世界一期社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區南雅南路二段124號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-yuanyang-nw1",
    "lat": 24.99704100613048,
    "lng": 121.45202815532706
  },
  {
    "id": "yuanyang-newworld-no2-lvr",
    "slug": "yuanyang-newworld-no2-lvr",
    "title": "遠揚新世界二期社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區南雅南路二段146號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-yuanyang-nw2",
    "lat": 24.996052939818902,
    "lng": 121.45165456099622
  },
  {
    "id": "yuanyang-xinzhan-lvr",
    "slug": "yuanyang-xinzhan-lvr",
    "title": "遠揚新站社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區南雅南路二段27號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-yuanyang-xinzhan",
    "lat": 24.99509896329667,
    "lng": 121.451625189501
  },
  {
    "id": "yuanyang-california-lvr",
    "slug": "yuanyang-california-lvr",
    "title": "遠揚加州社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區南雅南路二段120之3號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-yuanyang-california",
    "lat": 24.999743428134522,
    "lng": 121.4525801739296
  },
  {
    "id": "yuanyang-champagne-lvr",
    "slug": "yuanyang-champagne-lvr",
    "title": "遠揚香檳特區社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區南雅南路二段144巷69號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-yuanyang-champagne",
    "lat": 24.995347882578614,
    "lng": 121.45060094302009
  },
  {
    "id": "yuanyang-mingjia-lvr",
    "slug": "yuanyang-mingjia-lvr",
    "title": "遠揚名家社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區南雅南路二段144巷51號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-yuanyang-mingjia",
    "lat": 24.99517997785504,
    "lng": 121.45043782698923
  },
  {
    "id": "yuanyang-mingren-plaza-lvr",
    "slug": "yuanyang-mingren-plaza-lvr",
    "title": "遠揚名人廣場社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區南雅南路二段144巷68號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-yuanyang-mingren",
    "lat": 24.995160914363794,
    "lng": 121.45002625319432
  },
  {
    "id": "shennong527-lvr",
    "slug": "shennong527-lvr",
    "title": "連美One+社區步行圈實價登錄分析",
    "category": "comm",
    "district": "三重區",
    "address": "新北市三重區神農街527號",
    "priceUrl": "https://price.hooky-home.com/comm/sc-shennong919",
    "lat": 25.058988861031647,
    "lng": 121.4742448925975
  },
  {
    "id": "xingfufa-damei-lvr",
    "slug": "xingfufa-damei-lvr",
    "title": "興富發大美社區步行圈實價登錄分析",
    "category": "comm",
    "district": "板橋區",
    "address": "新北市板橋區華江九路1號",
    "priceUrl": "https://price.hooky-home.com/comm/bq-xingfufadamei",
    "lat": 25.032551888634238,
    "lng": 121.4662613933693
  },
  {
    "id": "qingniao-zhimei-lvr",
    "slug": "qingniao-zhimei-lvr",
    "title": "青鳥之美社區步行圈實價登錄分析",
    "category": "comm",
    "district": "三峽區",
    "address": "新北市三峽區橫溪路99巷103號",
    "priceUrl": "https://price.hooky-home.com/comm/ntp-sx-qingniaozhimei",
    "lat": 24.93834349630314,
    "lng": 121.40042379498502
  },
  {
    "id": "xinyi150-26-apt-lvr",
    "slug": "xinyi150-26-apt-lvr",
    "title": "板橋信義路150巷26號公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "板橋區",
    "address": "新北市板橋區信義路150巷26號",
    "priceUrl": "https://price.hooky-home.com/apt/bq-xinyi644",
    "lat": 24.991838240076508,
    "lng": 121.45795540928638
  },
  {
    "id": "changjiang1-91-apt-lvr",
    "slug": "changjiang1-91-apt-lvr",
    "title": "板橋長江路一段91號公寓步行圈實價登錄分析",
    "category": "apt",
    "district": "板橋區",
    "address": "新北市板橋區長江路一段91號",
    "priceUrl": "https://price.hooky-home.com/apt/bq-changjiang346",
    "lat": 25.0294771266563,
    "lng": 121.45908448052415
  },
  {
    "id": "datongnan150-apt-lvr",
    "slug": "datongnan150-apt-lvr",
    "title": "三重大同南路150號華廈步行圈實價登錄分析",
    "category": "comm",
    "district": "三重區",
    "address": "新北市三重區大同南路150號",
    "priceUrl": "https://price.hooky-home.com/comm/sc-datongnan150",
    "lat": 25.057808244583185,
    "lng": 121.49655133803904
  },
  {
    "id": "hexin-newstar-world-lvr",
    "slug": "hexin-newstar-world-lvr",
    "title": "合新NEW STAR世界之星社區步行圈實價登錄分析",
    "category": "comm",
    "district": "五股區",
    "address": "新北市五股區新五路三段202號",
    "priceUrl": "https://price.hooky-home.com/comm/ntp-wg-hexinnewstar",
    "lat": 25.089978744486057,
    "lng": 121.44632440172789
  }
];

class PriceCabinet extends SovereignCabinet {
    constructor() {
        super();
        this.map = null;
        this.reports = [...DEFAULT_REPORTS];
        this.filteredReports = [...this.reports];
        this.markersLayer = null;
        this.markerMap = new Map(); // id -> marker
        this.isVisible = false;

        // 先灌入後備模板，保證 DOM 立即就緒無白屏空窗
        this.setTemplate(FALLBACK_HTML, FALLBACK_CSS);
        this.ensureGlobalStyles();
        this.loadAssets('/js/cabinets/price');
    }

    onMount() {
        this.bindEvents();
        this.updateBadgeCount(this.reports.length);
        this.renderList();
        if (this.map && this.isVisible) {
            this.renderMarkers();
        }
        this.loadReports();
    }

    afterAssetsMounted() {
        this.bindEvents();
        this.updateBadgeCount(this.reports.length);
        this.renderList();
        if (this.map && this.isVisible) {
            this.renderMarkers();
        }
    }

    onMapReady(mapInstance) {
        this.map = mapInstance;
        this.ensureGlobalStyles();
        if (this.isVisible && this.reports.length > 0) {
            this.renderMarkers();
        }
    }

    ensureGlobalStyles() {
        if (typeof document === 'undefined') return;
        if (document.querySelector('link[data-price-map-css]')) return;
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '/css/price-map-overlays.css?v=price-popup-1';
        link.setAttribute('data-price-map-css', '1');
        document.head.appendChild(link);
    }

    onUnmount() {
        if (this.markersLayer && this.map) {
            this.markersLayer.clearLayers();
            this.map.removeLayer(this.markersLayer);
            this.markersLayer = null;
        }
        this.markerMap.clear();
    }

    async loadReports() {
        try {
            let res = await fetch('/js/cabinets/price/reports-index.json?v=' + Date.now());
            if (!res.ok) res = await fetch('/case-pages/reports-index.json?v=' + Date.now());
            if (!res.ok) return;
            const data = await res.json();
            if (Array.isArray(data.items) && data.items.length > 0) {
                this.reports = data.items;
                const searchInput = this.shadowRoot.getElementById('price-search');
                const q = searchInput ? searchInput.value.trim().toLowerCase() : '';
                if (!q) {
                    this.filteredReports = [...this.reports];
                } else {
                    this.filteredReports = this.reports.filter(r => 
                        (r.title && r.title.toLowerCase().includes(q)) ||
                        (r.address && r.address.toLowerCase().includes(q)) ||
                        (r.district && r.district.toLowerCase().includes(q))
                    );
                }
                this.updateBadgeCount(this.reports.length);
                this.renderList();
                if (this.map && this.isVisible) {
                    this.renderMarkers();
                }
            }
        } catch (err) {
            console.info('[PriceCabinet] 使用內建預設行情案例索引 (' + this.reports.length + ' 案)');
        }
    }

    bindEvents() {
        const toggle = this.shadowRoot.getElementById('toggle-price-layer');
        if (toggle && toggle.dataset.bound !== '1') {
            toggle.dataset.bound = '1';
            toggle.checked = this.isVisible;
            toggle.addEventListener('change', (e) => {
                this.isVisible = e.target.checked;
                this.syncPriceLayer();
            });
        }

        const searchInput = this.shadowRoot.getElementById('price-search');
        if (searchInput && searchInput.dataset.bound !== '1') {
            searchInput.dataset.bound = '1';
            searchInput.addEventListener('input', (e) => {
                const q = e.target.value.trim().toLowerCase();
                if (!q) {
                    this.filteredReports = [...this.reports];
                } else {
                    this.filteredReports = this.reports.filter(r => 
                        (r.title && r.title.toLowerCase().includes(q)) ||
                        (r.address && r.address.toLowerCase().includes(q)) ||
                        (r.district && r.district.toLowerCase().includes(q))
                    );
                }
                this.renderList();
            });
        }
    }

    updateBadgeCount(count) {
        const badge = this.shadowRoot.getElementById('price-count-badge');
        if (badge) {
            badge.textContent = count + ' 案';
        }
    }

    syncPriceLayer() {
        if (!this.map || typeof L === 'undefined') return;
        if (this.isVisible) {
            if (!this.markersLayer || this.markerMap.size === 0) {
                this.renderMarkers();
                return;
            }
            if (!this.map.hasLayer(this.markersLayer)) {
                this.markersLayer.addTo(this.map);
            }
            return;
        }
        if (this.markersLayer && this.map.hasLayer(this.markersLayer)) {
            this.map.removeLayer(this.markersLayer);
        }
    }

    renderMarkers() {
        if (!this.map || typeof L === 'undefined') return;
        if (!this.markersLayer) {
            this.markersLayer = L.layerGroup();
        }
        this.markersLayer.clearLayers();
        this.markerMap.clear();

        this.reports.forEach((item) => {
            if (!item.lat || !item.lng) return;

            // 簡易版行情 Logo DivIcon
            const iconHtml = `
                <div class="sovereign-price-marker" style="
                    width: 32px; height: 32px;
                    border-radius: 9px;
                    background: #0f172a;
                    border: 2px solid #f59e0b;
                    box-shadow: 0 3px 10px rgba(245, 158, 11, 0.4), 0 2px 4px rgba(0,0,0,0.6);
                    display: flex; align-items: center; justify-content: center;
                    cursor: pointer;
                    transition: transform 0.2s ease;
                ">
                    <img src="/images/logo-price-icon.svg" width="20" height="20" alt="行情" style="display:block;" />
                </div>
            `;

            const customIcon = L.divIcon({
                className: 'price-marker-wrap',
                html: iconHtml,
                iconSize: [32, 32],
                iconAnchor: [16, 16],
                popupAnchor: [0, -18]
            });

            const marker = L.marker([item.lat, item.lng], { icon: customIcon });

            const catLabel = item.category === 'apt' ? '公寓步行圈' : (item.category === 'comm' ? '大樓社區' : '房產行情');
            const popupHtml = `
                <div class="price-popup-inner">
                    <div class="price-popup-kicker">
                        <span class="price-popup-cat">${catLabel}</span>
                        <span class="price-popup-district">${item.district || ''}</span>
                    </div>
                    <div class="price-popup-title">${item.title}</div>
                    <div class="price-popup-addr">📍 ${item.address || '標準層周邊'}</div>
                    <a class="price-popup-cta" href="${item.priceUrl}" target="_blank" rel="noopener">
                        <img src="/images/logo-price-icon.svg" width="16" height="16" alt="" />
                        查看完整行情數據分析
                    </a>
                </div>
            `;

            marker.bindPopup(popupHtml, { className: 'price-leaflet-popup', maxWidth: 320 });
            marker.addTo(this.markersLayer);
            this.markerMap.set(item.id, marker);
        });

        if (this.isVisible && !this.map.hasLayer(this.markersLayer)) {
            this.markersLayer.addTo(this.map);
        }
    }

    renderList() {
        const listEl = this.shadowRoot.getElementById('price-items');
        if (!listEl) return;

        if (this.filteredReports.length === 0) {
            listEl.innerHTML = '<div class="empty-state">無符合條件的行情案例</div>';
            return;
        }

        listEl.innerHTML = '';
        this.filteredReports.forEach((item) => {
            const card = document.createElement('div');
            card.className = 'price-item';

            const catText = item.category === 'apt' ? '公寓' : (item.category === 'comm' ? '大樓' : '行情');

            card.innerHTML = `
                <div class="price-item-top">
                    <span class="price-item-title" title="${item.title}">${item.title}</span>
                    <span class="price-item-cat">${catText}</span>
                </div>
                <div class="price-item-meta">📍 ${item.district} · ${item.address || '重點區域'}</div>
                <div class="price-item-actions">
                    <a class="price-cta-btn" href="${item.priceUrl}" target="_blank" rel="noopener" title="在新分頁開啟完整報告">
                        <img src="/images/logo-price-icon.svg" alt="icon" />
                        查看完整行情數據分析
                    </a>
                </div>
            `;

            // 點擊卡片定位地圖
            card.addEventListener('click', (e) => {
                if (e.target.closest('a')) return; // 若點擊的是連結則不搶事件
                this.locateItem(item);
            });

            listEl.appendChild(card);
        });
    }

    locateItem(item) {
        if (!this.map || !item.lat || !item.lng) return;
        if (!this.isVisible) {
            this.isVisible = true;
            const toggle = this.shadowRoot?.getElementById('toggle-price-layer');
            if (toggle) toggle.checked = true;
        }
        this.syncPriceLayer();
        this.map.flyTo([item.lat, item.lng], 16, { duration: 1.2 });
        const marker = this.markerMap.get(item.id);
        if (marker) {
            setTimeout(() => {
                marker.openPopup();
            }, 600);
        }
    }
}

customElements.define('price-cabinet', PriceCabinet);

function dock() {
    if (!window.appCore) return;
    const container = document.getElementById('socket-price');
    if (!container) return;
    let instance = window.appCore.getCabinet('price');
    if (!instance) {
        instance = document.createElement('price-cabinet');
        window.appCore.registerCabinet('price', instance);
    }
    if (!container.contains(instance)) {
        container.innerHTML = '';
        container.appendChild(instance);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dock);
} else {
    dock();
}

export { PriceCabinet };
